import React from "react";
import VisCard from "./VisCard";
import Contact from "./Contact";
import Navbar from "./Navbar";
function Contactpage()
{
    return(
        <>
        <Navbar/>
        <VisCard/>
        <Contact/>
        </>
    )
}
export default Contactpage;